class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    this.hoverMedia = window.matchMedia('(min-width: 990px)');
    this.closeHoverTimeout = null;
    this.boundOpenOnHover = this.openOnHover.bind(this);
    this.boundScheduleCloseOnHover = this.scheduleCloseOnHover.bind(this);
    this.boundSyncHoverListeners = this.syncHoverListeners.bind(this);
    this.hoverMedia.addEventListener('change', this.boundSyncHoverListeners);
    this.syncHoverListeners();
  }

  syncHoverListeners() {
    if (this.hoverMedia.matches) {
      this.addEventListener('mouseenter', this.boundOpenOnHover);
      this.addEventListener('mouseleave', this.boundScheduleCloseOnHover);
    } else {
      this.removeEventListener('mouseenter', this.boundOpenOnHover);
      this.removeEventListener('mouseleave', this.boundScheduleCloseOnHover);
      this.cancelCloseOnHover();
    }
  }

  openOnHover() {
    this.cancelCloseOnHover();
    this.mainDetailsToggle.setAttribute('open', '');
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.setAttribute('aria-expanded', 'true');
  }

  scheduleCloseOnHover() {
    this.cancelCloseOnHover();
    if (!this.matches(':hover') && !this.contains(document.activeElement)) {
      this.close();
    }
  }

  cancelCloseOnHover() {
    if (this.closeHoverTimeout) {
      clearTimeout(this.closeHoverTimeout);
      this.closeHoverTimeout = null;
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
